require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/analytics/legacy/perso/lvp.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/analytics/legacy/perso/lvp.legacy.js
// module id = 807
// module chunks = 31